/**
 * Canonical storefront + contact (NAP) — single source for UI + JSON-LD.
 * Align with Footer, PhoneButton, and Map embed.
 */

export const BUSINESS_NAME = "Shine Bright Auto Solutions";

export const PHONE_DIGITS = "6786798105";
export const PHONE_DISPLAY = "678-679-8105";
export const PHONE_TEL_HREF = `tel:${PHONE_DIGITS}`;
/** E.164 for schema.org `telephone` */
export const PHONE_E164 = "+16786798105";

export const EMAIL = "shinebrightautosolutions@gmail.com";
export const MAILTO_HREF = `mailto:${EMAIL}`;

export const ADDRESS_STREET = "5215 Palmero Ct";
export const ADDRESS_CITY = "Buford";
export const ADDRESS_REGION = "GA";
export const ADDRESS_POSTAL = "30518";
export const ADDRESS_COUNTRY = "US";

/** Short line for “service area” copy */
export const SERVICE_AREA_SHORT = "Atlanta Metro Area, GA";

export const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3302.4426583810177!2d-83.96506628910814!3d34.135015513243715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5eba05682fab1%3A0xa834da93d0948c61!2sShine%20Bright%20Auto%20Solutions!5e0!3m2!1sen!2sus!4v1773791190823!5m2!1sen!2sus";

export const MAP_LABEL = `${BUSINESS_NAME} — ${ADDRESS_STREET}, ${ADDRESS_CITY}, ${ADDRESS_REGION} ${ADDRESS_POSTAL}`;
export const MAP_ARIA_LABEL = `Google Maps showing ${BUSINESS_NAME} at ${ADDRESS_STREET}, ${ADDRESS_CITY}, ${ADDRESS_REGION} ${ADDRESS_POSTAL}`;

/** From Google Maps embed (center / place pin) */
export const GEO_LATITUDE = 34.135015513243715;
export const GEO_LONGITUDE = -83.96506628910814;

export const SOCIAL_LINKS = [
  "https://www.instagram.com/shine.bright.auto.solutions/",
  "https://www.facebook.com/ShineBrightDetailingATL",
  "https://www.youtube.com/@shinebrightautosolutions",
] as const;

/** Public site origin for absolute URLs in JSON-LD. Set `VITE_SITE_URL` in deploy env. */
export const SITE_URL =
  (typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_SITE_URL &&
    String(import.meta.env.VITE_SITE_URL).trim()) ||
  "https://shinebrightway.lovable.app";

export const SITE_URL_NORMALIZED = SITE_URL.replace(/\/$/, "");

export function jsonLdPostalAddress() {
  return {
    "@type": "PostalAddress" as const,
    streetAddress: ADDRESS_STREET,
    addressLocality: ADDRESS_CITY,
    addressRegion: ADDRESS_REGION,
    postalCode: ADDRESS_POSTAL,
    addressCountry: ADDRESS_COUNTRY,
  };
}

export function jsonLdGeoCoordinates() {
  return {
    "@type": "GeoCoordinates" as const,
    latitude: GEO_LATITUDE,
    longitude: GEO_LONGITUDE,
  };
}

/** Provider block reused by Service JSON-LD */
export function jsonLdAutoRepairProvider() {
  return {
    "@type": "AutoRepair" as const,
    name: BUSINESS_NAME,
    telephone: PHONE_E164,
    address: jsonLdPostalAddress(),
  };
}

/** Shown on Privacy / Terms pages */
export const LEGAL_LAST_UPDATED = "March 24, 2025";
